/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DataEnrichmentListCreateRequestDto } from '../models/DataEnrichmentListCreateRequestDto';
import type { DataEnrichmentPreviewEntryDto } from '../models/DataEnrichmentPreviewEntryDto';
import type { DataEnrichmentPreviewRequestDto } from '../models/DataEnrichmentPreviewRequestDto';
import type { DataEnrichmentSelectUnmatchedEntriesRequestDto } from '../models/DataEnrichmentSelectUnmatchedEntriesRequestDto';
import type { GetDataEnrichmentMatchSuggestionDto } from '../models/GetDataEnrichmentMatchSuggestionDto';
import type { ListCreatedDto } from '../models/ListCreatedDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ListsEnrichmentService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns DataEnrichmentPreviewEntryDto
     * @throws ApiError
     */
    public preview({
        requestBody,
    }: {
        requestBody: DataEnrichmentPreviewRequestDto,
    }): CancelablePromise<Array<DataEnrichmentPreviewEntryDto>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/lists/enrichment/preview',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ListCreatedDto
     * @throws ApiError
     */
    public createEnrichedList({
        requestBody,
    }: {
        requestBody: DataEnrichmentListCreateRequestDto,
    }): CancelablePromise<ListCreatedDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/lists/enrichment/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public discardUnmatchedEntry({
        id,
        entryId,
    }: {
        id: string,
        entryId: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/lists/enrichment/list/{id}/unmatched-items/{entry_id}',
            path: {
                'id': id,
                'entry_id': entryId,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public matchUnmatchedEntries({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: DataEnrichmentSelectUnmatchedEntriesRequestDto,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/lists/enrichment/list/{id}/unmatched-items/matches',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns GetDataEnrichmentMatchSuggestionDto
     * @throws ApiError
     */
    public getUnmatchedItems({
        id,
        itemsPerPage,
        page,
        query,
    }: {
        id: string,
        itemsPerPage: number,
        page: number,
        query?: string,
    }): CancelablePromise<GetDataEnrichmentMatchSuggestionDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/lists/enrichment/list/{id}/unmatched-items',
            path: {
                'id': id,
            },
            query: {
                'query': query,
                'items_per_page': itemsPerPage,
                'page': page,
            },
        });
    }
}
